import { ChargeFlag } from '@/@types/generated'
import { register } from './enum'

// Status flags shown on the Payments Management table's "Applies To" cell (badges). None of
// these are resolvable yet (delete reasons aren't tracked on payments yet), so `flags` is empty for every charge today; the formatting is wired up now
// so the badges render correctly once the backend starts populating them.
export const ChargeFlagLabels: Record<ChargeFlag, string> = {
  [ChargeFlag.DELETED_DUPLICATE]: 'Deleted duplicate',
  [ChargeFlag.DELETED]: 'Deleted',
}

// Neutral outline shared by the "Deleted" flag and by the charge badges
export const CHARGE_FLAG_NEUTRAL_OUTLINE =
  'bg-muted text-foreground border-border'

export const ChargeFlagClassNames: Record<ChargeFlag, string> = {
  [ChargeFlag.DELETED_DUPLICATE]:
    'bg-warning-background text-warning-foreground border-warning',
  [ChargeFlag.DELETED]: CHARGE_FLAG_NEUTRAL_OUTLINE,
}

register<ChargeFlag>(ChargeFlag, (v) => {
  if (!v) return '—'
  return ChargeFlagLabels[v]
})
